import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRootRoute, Outlet } from '@tanstack/react-router';

const queryClient = new QueryClient();

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <div className="flex flex-col absolute top-0 bottom-0 left-0 right-0 h-screen">
        <div className="flex flex-col grow min-h-screen overflow-auto">
          <Outlet />
        </div>
      </div>
    </QueryClientProvider>
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    rootRoute: typeof Route;
  }
}
